var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message-search" },
    [
      _c("a-input-search", {
        attrs: {
          size: "large",
          placeholder: "Mesajlarda ara...",
          loading: _vm.isLoading,
          "allow-clear": "",
        },
        on: { search: _vm.handleSearch, change: _vm.handleInputChange },
        model: {
          value: _vm.searchQuery,
          callback: function ($$v) {
            _vm.searchQuery = $$v
          },
          expression: "searchQuery",
        },
      }),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "loading-container" },
            [_c("a-spin", { attrs: { size: "large" } })],
            1
          )
        : _vm.groupedResults.length
        ? _c(
            "div",
            { staticClass: "search-results" },
            _vm._l(_vm.groupedResults, function (group) {
              return _c(
                "div",
                { key: group.visitorId, staticClass: "result-group" },
                [
                  _c("div", { staticClass: "visitor-info" }, [
                    _c(
                      "div",
                      { staticClass: "visitor-header" },
                      [
                        _c("h3", [
                          _vm._v(
                            _vm._s(group.visitorName || "İsimsiz Ziyaretçi")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("SupsisButton", {
                          attrs: { icon: "person", xxsmall: "" },
                          on: {
                            click: function ($event) {
                              return _vm.viewContactProfile(group.visitorId)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "message-count" }, [
                      _vm._v(_vm._s(group.messages.length) + " mesaj"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "messages" },
                    _vm._l(group.messages, function (message) {
                      return _c(
                        "div",
                        {
                          key: message._id,
                          staticClass: "message-item",
                          attrs: {
                            "data-id": message._id,
                            "data-visitor-id": message.visitor._id,
                            "data-conversation-id": message.conversation._id,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openChatHistory(
                                message.conversation._id,
                                message.visitor._id
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "message-header" }, [
                            _c(
                              "div",
                              { staticClass: "sender-info" },
                              [
                                message.messageType.includes("user")
                                  ? _c("AgentAvatar", {
                                      attrs: {
                                        userID: message.user,
                                        size: 35,
                                        fontSize: 12,
                                      },
                                    })
                                  : _c("ContactAvatar", {
                                      attrs: {
                                        contact: message.visitor,
                                        size: "smallest",
                                      },
                                    }),
                                _vm._v(" "),
                                _c("span", { staticClass: "sender-name" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.getSenderName(message)) +
                                      "\n                            "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "message-actions" },
                              [
                                _c("span", { staticClass: "message-date" }, [
                                  _vm._v(
                                    _vm._s(_vm.formatDate(message.createdDate))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.openChatHistory(
                                          message.conversation._id,
                                          message.visitor._id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Sohbeti Aç\n                            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "message-content" }, [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$sanitize(message.description)
                                ),
                              },
                            }),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            }),
            0
          )
        : _vm.searched
        ? _c(
            "div",
            { staticClass: "no-results" },
            [_c("a-empty", { attrs: { description: "Sonuç bulunamadı" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedVisitorId
        ? _c("UserChatHistoryWidget", {
            attrs: {
              "visitor-id": _vm.selectedVisitorId,
              "conversation-id": _vm.selectedConversationId,
            },
            on: { close: _vm.closeChatHistory },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }